/**
 * 収運・処分業者データ補完
 */
import * as httpConst from "@/constants/httpConst";
import Vue from "vue";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/transfers/traders`

const getDefaultState = () => {
  return {}
}

const transferTrader =  {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    /**
     * 収運・処分業者データ補完 登録
     * @param commit
     * @param params
     * @returns {Promise<unknown>}
     */
    create({ commit }, { params }){
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          if (!data.result.code) {
            commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          }
          resolve(content)
        })
      })
    },
  }
};

export default transferTrader;
